import { X } from 'lucide-react';
import { POPULAR_EMOJI } from '@/lib/reference/popular-emoji';

interface Props {
  onPick: (emoji: string) => void;
  onClose: () => void;
}

export function EmojiPicker({ onPick, onClose }: Props) {
  return (
    <div className="absolute bottom-[calc(100%+6px)] left-0 right-0 z-50 max-h-[200px] overflow-y-auto rounded-[14px] bg-paper p-3 shadow-bt-lg">
      <div className="mb-2 flex items-center justify-between">
        <div className="text-[11px] font-semibold tracking-[-0.005em] text-ink-soft">Frequently used</div>
        <button type="button" onClick={onClose} className="bt-flat p-0.5 text-mute">
          <X size={14} />
        </button>
      </div>
      <div className="grid grid-cols-8 gap-1">
        {POPULAR_EMOJI.map((e, i) => (
          <button
            key={`${e}-${i}`}
            type="button"
            onClick={() => onPick(e)}
            className="bt-flat rounded-md py-2 text-xl leading-none hover:bg-cream emoji"
          >
            {e}
          </button>
        ))}
      </div>
    </div>
  );
}
